<template>
  <b-modal id="changePlantModal" @ok="onOk" body-class="p-0" title="Cambiar de cliente" @show="onShow">
    <b-form>
      <b-form-select v-model="selected" :options="options"> </b-form-select>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "ChangePlant",
  data() {
    return {
      loading: false,
      options: [{ value: 0, text: "Todas" }],
      selected: null
    };
  },
  methods: {
    onShow() {
      this.fetchPlants();
    },
    async fetchPlants() {
      this.options = [];
      try {
        const res = await this.$axios.get("/production/get_plants/");
        this.options.push({ value: 0, text: "Todas" });
        for (let item of res.data.data) {
          if (item.operations === true) {
            this.options.push({ value: item.value, text: item.text });
          }
        }
        // Push at the beginning a null option
        this.selected = this.$store.state.user.plant;
      } catch (error) {
        this.$bvToast.toast(error.response.data.message, {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    async onOk() {
      this.loading = true;
      try {
        const res = await this.$axios.post("/menu_app/change_plant/" + this.selected + "/");
        this.$bvToast.toast(res.data.message, {
          title: "Éxito",
          variant: "success",
          solid: true
        });
        window.location.reload();
      } catch (error) {
        this.$bvToast.toast(error.response.data.message, {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
